export default __webpack_public_path__ + "static/media/downLoadIcon.8b54a84c.svg";